import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

import Button from "../Button";

import * as styles from "./PageHeader.module.css";

const PageHeader = ({ props }) => {
  const {
    backgroundImage,
    backgroundColor,
    headline,
    subHeadline,
    details,
    callsToActions,
    textAlign,
    benefit1,
    benefit2,
    benefit3,
    benefit4,
    pageHeaderImage,
    introCopyBackgroundColor,
    introCopyA,
    enableLargeIntroCopyA,
    introCopyB,
    enableLargeIntroCopyB,
    minimizePadding,
  } = props;

  const backgroundImageSrc = backgroundImage && getImage(backgroundImage.file);
  const pageHeaderImageSrc = pageHeaderImage && getImage(pageHeaderImage.file);

  return (
    <div
      className={`${styles.pageHeader} ${styles[backgroundColor]} ${
        minimizePadding && styles["minimizePadding"]
      }`}
    >
      <div className={`${styles.content} ${styles[textAlign]}`}>
        <h1
          // data-aos="fade-up"
          // data-aos-duration="200"
          className="headline"
        >
          {headline}
        </h1>

        {subHeadline && (
          <h3
            // data-aos="fade-up"
            // data-aos-duration="500"
            className={styles.subHeadline}
          >
            {subHeadline}
          </h3>
        )}

        {details && (
          <div
            // data-aos="fade-up"
            // data-aos-duration="700"
            className={styles.details}
            dangerouslySetInnerHTML={{
              __html: details.childMarkdownRemark.html,
            }}
          />
        )}
        {callsToActions && callsToActions.length > 0 && (
          <div className={styles.callsToActions}>
            {callsToActions.map((cta, index) => (
              <div
                key={index}
                // data-aos="fade-up"
                // data-aos-duration="800"
              >
                <Button
                  key={index}
                  styleAsButton={cta.styleAsButton}
                  destination={cta.to}
                >
                  {cta.title}
                </Button>
              </div>
            ))}
          </div>
        )}
        {(benefit1 || benefit2 || benefit3 || benefit4) && (
          <div className={styles.benefits}>
            {benefit1 && (
              <>
                <span
                // data-aos="fade-up"
                // data-aos-duration="500"
                >
                  <FontAwesomeIcon icon={faCheck} color="red" size="xl" />
                  <span className={styles.benefitText}>{benefit1}</span>
                </span>
              </>
            )}
            {benefit2 && (
              <span
              // data-aos="fade-up"
              // data-aos-duration="600"
              >
                <FontAwesomeIcon icon={faCheck} color="red" size="xl" />
                <span className={styles.benefitText}>{benefit2}</span>
              </span>
            )}
            {benefit3 && (
              <span
              // data-aos="fade-up"
              // data-aos-duration="800"
              >
                <FontAwesomeIcon icon={faCheck} color="red" size="xl" />
                <span className={styles.benefitText}>{benefit3}</span>
              </span>
            )}
            {benefit4 && (
              <span
              // data-aos="fade-up"
              // data-aos-duration="1000"
              >
                <FontAwesomeIcon icon={faCheck} color="red" size="xl" />
                <span className={styles.benefitText}>{benefit4}</span>
              </span>
            )}
          </div>
        )}
      </div>

      {pageHeaderImage && (
        <div className={styles.pageHeaderImageContainer}>
          <GatsbyImage
            image={pageHeaderImageSrc}
            alt={pageHeaderImage.file.description}
            className={styles.pageHeaderImage}
            loading="eager"
          />
        </div>
      )}
      {introCopyA && introCopyB ? (
        <div
          className={`${styles.introCopy} ${
            introCopyBackgroundColor && styles[introCopyBackgroundColor]
          }`}
        >
          <div className={styles.introCopyContent}>
            <div
            // data-aos="fade-in"
            // data-aos-duration="500"
            >
              <span
                className={enableLargeIntroCopyA && styles["large"]}
                dangerouslySetInnerHTML={{
                  __html: introCopyA.childMarkdownRemark.html,
                }}
              />
            </div>
            <div
            // data-aos="fade-in"
            // data-aos-duration="900"
            >
              <span
                className={enableLargeIntroCopyB && styles["large"]}
                dangerouslySetInnerHTML={{
                  __html: introCopyB.childMarkdownRemark.html,
                }}
              />
            </div>
          </div>
        </div>
      ) : null}
      {backgroundImage && (
        <GatsbyImage
          image={backgroundImageSrc}
          alt={backgroundImage.file.description}
          className={styles.backgroundImage}
          loading="eager"
        />
      )}
    </div>
  );
};

export default PageHeader;
